export default "__VITE_ASSET__KKQk$lDk__"